<kendo-loader [type]="type" [themeColor]="themeColor" [size]="size">
</kendo-loader>
